/* eslint react/prop-types: 0 */
/* eslint react/no-array-index-key: 0 */
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    section: {
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center',
        gridGap: '30px',
        gridAutoFlow: 'column',
        fontSize: '11px',
    },
});

const extractMinMaxMeanData = (def, data) => {
    if (!data || !def) return [];

    return def.map((item) => {
        const name = item.label;
        const metric = data[item.metric];
        const rawValue = metric !== undefined ? item.metricFn(metric) : undefined;
        const value = rawValue !== undefined ? `${rawValue}${item.postfix}` : '-';
        return {
            name,
            value,
        };
    });
};

export default function MinMaxMean({ def, data }) {
    const minMaxData = extractMinMaxMeanData(def, data);
    const classes = useStyles();

    const filtered = minMaxData?.filter((item) => item.name);
    if (!filtered) return null;
    return (
        <div className={classes.section}>
            {filtered.map((item, idx) => (
                <div key={idx}>
                    <b>{item.name}</b>: {item.value}
                </div>
            ))}
        </div>
    );
}
